import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, of, throwError } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { SegnalazioniService } from './eventi-segnalazioni.service';

@Injectable({
  providedIn: 'root'
})
export class EventiSegnalazioniDataSource implements DataSource<ModelEventiCalamitosi.EventoDto> {

  private segnalazioneSubject = new BehaviorSubject<ModelEventiCalamitosi.EventoDto[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  private errorSubject = new BehaviorSubject<boolean>(false);
  public errors$ = this.errorSubject.asObservable();
  isLoading: boolean = false;
  errorMessage: string = null;

  private countSubject = new BehaviorSubject<number>(0);
  public counter$ = this.countSubject.asObservable();

  constructor(private segnalazioniSvc: SegnalazioniService) {
  }

  loadSegnalazioni(ipa: string,
    filter: ModelEventiCalamitosi.EventiSearchableDto,
    sortDirection: string,
    pageIndex: number,
    pageSize: number,
    idEnte: number
    ) {

    this.loadingSubject.next(true);

    this.segnalazioniSvc.getEventListByEnte(idEnte, pageIndex, pageSize, sortDirection, {
      idEvento: filter.idEvento,
      dpgr: filter.dpgr,
      descrizione: filter.descrizione,
      stato: filter.stato,
      attiAmmiComm: filter.attiAmmiComm,
      ocdpc: filter.ocdpc,
      dataEventoDa: filter.dataEventoDa,
      dataEventoA: filter.dataEventoA,
      primaDataChiusuraRaccolta: filter.primaDataChiusuraRaccolta,
      inviato: filter.inviato
    }).pipe(
      catchError(err => {
      this.errorSubject.next(true);
      return throwError(err);
    }),
    catchError(err => {
      return of([]);
    }),
      finalize(() => this.loadingSubject.next(false))
    )
      .subscribe(result => {
        this.segnalazioneSubject.next(result['content']);
        this.countSubject.next(result['totalElements']);
      }
      );
  }

  connect(collectionViewer: CollectionViewer): Observable<ModelEventiCalamitosi.EventoDto[]> {
    return this.segnalazioneSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.segnalazioneSubject.complete();
    this.loadingSubject.complete();
  }

}

